import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTerms } from './useTerms';
import { useTermActions } from './useTermActions';

// O backend pode devolver um objeto em erros de validação; renderizar objeto
// como filho quebra o React, então coagimos para texto antes de exibir.
const toErrorText = (data) =>
  typeof data === 'string' && data ? data : 'Não foi possível concluir a operação.';

// Orquestra a tela de configuração de termos. Consumido pelas versões web e
// mobile, que ficam responsáveis apenas pela apresentação.
export function useTermsScreen() {
  const navigate = useNavigate();

  const { terms, isLoading: isTermsLoading, error: listError, refetch: getTerms } = useTerms();
  const { remove, fetchUrl } = useTermActions();

  const [isLoading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (listError) {
      setShowErrorMessage(true);
      setErrorMessage(toErrorText(listError));
    }
  }, [listError]);

  const deleteTerm = useCallback(
    (termId) => {
      setLoading(true);
      return remove(termId)
        .then((returnFromApi) => {
          setSuccessMessage(toErrorText(returnFromApi.data));
          setShowSuccessMessage(true);
          getTerms();
        })
        .catch((returnFromApi) => {
          setShowErrorMessage(true);
          setErrorMessage(toErrorText(returnFromApi.response?.data));
          console.error('ops! ocorreu um erro' + returnFromApi);
          if (returnFromApi.status === 401) {
            navigate('/expired-session');
          }
        })
        .finally(() => setLoading(false));
    },
    [remove, getTerms, navigate],
  );

  const downloadTerm = useCallback(
    (termId) => {
      setLoading(true);
      return fetchUrl(termId)
        .then((returnFromApi) => {
          window.location.href = returnFromApi.data;
        })
        .catch((returnFromApi) => {
          setShowErrorMessage(true);
          setErrorMessage(toErrorText(returnFromApi.response?.data));
          console.error('ops! ocorreu um erro' + returnFromApi);
          if (returnFromApi.status === 401) {
            navigate('/expired-session');
          }
        })
        .finally(() => setLoading(false));
    },
    [fetchUrl, navigate],
  );

  const onSavedTerm = useCallback(
    (returnFromApi) => {
      if (returnFromApi.data) {
        setShowSuccessMessage(true);
        setSuccessMessage(toErrorText(returnFromApi.data));
      } else {
        setShowErrorMessage(true);
        setErrorMessage(toErrorText(returnFromApi.response?.data));
      }
      getTerms();
    },
    [getTerms],
  );

  return {
    terms,
    isLoading: isLoading || isTermsLoading,
    deleteTerm,
    downloadTerm,
    onSavedTerm,
    showSuccessMessage,
    setShowSuccessMessage,
    successMessage,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
  };
}
